import { games } from "../types"
import GameListItem from "./GameListItem"

export default function GamesList() {
    return <>
        <h2>Wannabet Games</h2>
        <div style={{ display: "flex", overflowX: "auto", gap: 20, paddingTop: 20, paddingBottom: 20 }}>
            {games.map((game, index) =>
                <GameListItem game={game} key={index} />
            )}
        </div>
    </>
};